import React from "react";
import "./App.css"
import Footer from "./Footer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Home";
import Quote from "./Quote";
import Navbar from "./Navbar";
import About from "./About";
import Contact from "./Contact";
import FAQ from "./FAQ";
import Location from "./Location";
import ScrollToTop from "./ScrollToTop";
import Achievement from "./Achievement";
import Shop from "./Shop";
import AllProducts from "./AllProducts";
import { Bed, Sofa, Table } from "lucide-react";
import Sofas from "./Sofas";
import Tables from "./Table";
import Beds from "./Beds";
import Details from "./ProductDetails";
import Search from "./Search";
function App() {
 

  return (
    <>
    <BrowserRouter>
       <Navbar/>
<ScrollToTop/>
    <Routes>

      <Route path="/" element={<Home/>}/>
      <Route path="/shop" element={<Shop/>}/>
      <Route path="/sofas" element={<Sofas/>}/>
      <Route path="/tables" element={<Tables/>}/>
      <Route path="/beds" element={<Beds/>}/>



      <Route path="/products" element={<AllProducts/>}/>
      <Route path="/products/:id" element={<Details/>}/>
      <Route path="/search" element={<Search/>}/>


      


      <Route path="/quote" element={<Quote/>}/>
   <Route path="/about" element={<About/>}/>
<Route path="/contact" element={<Contact/>}/>
      <Route path="/faq" element={<FAQ/>}/>
      <Route path="/location" element={<Location/>}/>
    </Routes>
    <Achievement/>
     <Footer/>

    </BrowserRouter>

</>
  );
}

export default App;
